import { getFrontendConfig } from '../config/frontendConfig';

/**
 * Initialize window globals that the legacy code expects.
 * Previously these were injected server-side by _SharedLayout.cshtml.
 */
export function initWindowGlobals() {
    const frontendConfig = getFrontendConfig();

    // URL globals used by UrlUtilities
    (window as any).BASE_URL = frontendConfig.urls.apiBaseUrl;
    (window as any).APP_URL = frontendConfig.urls.appPath;
    (window as any).HELP_URL = frontendConfig.urls.helpUrl;
    (window as any).BASE_APP_PATH = frontendConfig.urls.basePath;

    // Permissions — will be populated after API call
    (window as any).Permissions = (window as any).Permissions || [];

    // Applications — will be populated after API call
    (window as any).Applications = (window as any).Applications || [];

    // Content version for cache busting
    (window as any).ContentVersion = import.meta.env.VITE_BUILD_NUMBER;
}

export function applyAuthBootstrapGlobals(permissions: string[] = [], applications: string[] = []) {
    (window as any).Permissions = permissions;
    (window as any).Applications = applications;
}

export function clearAuthBootstrapGlobals() {
    applyAuthBootstrapGlobals([], []);
}
